import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import ConfiguredComponent from './ConfiguredComponent.component';
import makeConfiguration from './makeConfiguration';
import { importComponent } from './importComponent';

export const loader = components => idOrDescriptor => {
  const descriptor =
    typeof idOrDescriptor === 'string'
      ? components[idOrDescriptor]
      : idOrDescriptor;
  if (!descriptor) {
    throw new Error(`Unable to load component ${idOrDescriptor}`);
  }

  return (
    <ConfiguredComponent
      key={JSON.stringify(descriptor)}
      Component={lazy(importComponent(descriptor))}
      loader={loader(components)}
      useConfiguration={makeConfiguration(descriptor)}
    />
  );
};

const ConfiguredComponentLoader = ({ components, id }) =>
  loader(components)(id);

ConfiguredComponentLoader.propTypes = {
  components: PropTypes.object,
  id: PropTypes.string,
};

export default ConfiguredComponentLoader;
